export default () => {
    const forwardDeleteModal = document.getElementById('forwardDeleteModal');
    if (!forwardDeleteModal) {
        return;
    }
    forwardDeleteModal.addEventListener('show.bs.modal', (event) => {
        const { forward, email, action } = event.relatedTarget.dataset;

        forwardDeleteModal.querySelector('#forwardDelete').setAttribute('action', action);
        forwardDeleteModal.querySelector('#email').value = email;
        forwardDeleteModal.querySelector('.forward').value = forward;
    });
};
